module.exports = "//docs.gtimg.com/slide/img/page/toc/common/meeting-room-manager/img/svg/waiting-c326ee.svg";